// extracted by mini-css-extract-plugin
export var calendarView = "_md-0";